import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {LinkShape} from '../utils/react/Shapes';
import DeepLink from './DeepLink';

class LinkGroup extends Component {
  static propTypes = {
    links: PropTypes.arrayOf(LinkShape),
    showFavorite: PropTypes.bool
  };

  render() {
    const { links, showFavorite = false } = this.props;
    const linksToRender = links.map((link, i) => {
      return <DeepLink key={ i } link={ link } showFavorite={ showFavorite }/>;
    });

    return <div className='link-group card-deck flex-container flex-justify-center'>
      { linksToRender }
    </div>;
  }
}

export default LinkGroup;



// WEBPACK FOOTER //
// ./src/components/LinkGroup.js